<template>
  <vcl-facebook v-if="loading"></vcl-facebook>
  <div v-else-if="!loading && result && result.id">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card class="text-center" style="font-size:1.3em">
          <b-row>
            <b-col md="12">
              <h1> {{result.fqdn}} </h1>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>총 페이지 <br><small>(페이지 + 외부 + 리소스)</small> </label><br>
                <label for="ph_page">{{ result.page_count | number }} 개</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>점검 시간</label>
                (
                <b-badge variant="primary">
                {{moment(result.finished_at).diff(result.started_at, 'minutes') == 0 ? "1 분 미만" : `${moment(result.finished_at).diff(result.started_at, 'minutes')} 분`  }}
                </b-badge>
                )
                <p>{{result.started_at | datetime}} ~ {{result.finished_at | datetime}}</p>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_detect_count" v-b-tooltip.hover>탐지 페이지</label><br>
                <b-badge variant="danger" v-if="result.detect_count > 0"> {{result.detect_count}} 개 </b-badge>
                <span v-else>-</span>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>상태</label><br>
                <b-badge v-if="result.finished_at" :variant="result.finished_at ? 'info' : 'light'"> {{result.finished_at ? 'Finished' : 'Scanning'}} </b-badge>
                <b-badge v-if="result.error_count > 0" variant="warning"> {{result.error_count ? 'Error' : 'Scanning'}} </b-badge>
                <br>
                <b-badge v-if="result.is_js" variant="info"> JS 이벤트</b-badge>
                <div v-if="result.is_login">
                  <b-badge variant="info"> 로그인 사용</b-badge>
                  <b-badge v-if="result.is_login_success" variant="success"> 로그인 성공</b-badge>
                  <b-badge v-else variant="warning"> 로그인 실패</b-badge>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="4" class="animated fadeIn fadeOut">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>스크린샷</label><br>
                <img class="border" :src="image" :style="{ width: thumbnail_size }">
              </b-form-group>
            </b-col>
            <b-col md="4" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>사이트 점검 요약</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_site" :series="data_site"></vue-apex-charts>
              </center>
            </b-col>
            <b-col md="4" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>사이트 리소스 비율</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_resource" :series="data_resource"></vue-apex-charts>
              </center>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>탐지 목록</strong> <small>탐지 페이지 목록 {{result.detect_count | number}} 개 ({{result.detect.start+(result.detect_count ? 1: 0)}} ~ {{result.detect.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.detect_count === 0"><template><div>데이터가 없습니다.</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('detect')" ref="detect_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.detect.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong v-b-tooltip.hover title="에러 페이지로 위장하여 악성코드가 배포될 수 있습니다 인지하고 있는 에러 페이지 여부를 확인합니다">
              에러 페이지
              <span class="text-info">
                <i style="cursor:pointer" class="fas fa-question-circle"></i>
              </span>
            </strong>
            <small>페이지 목록 {{result.error_count || 0 | number}} 개 ({{result.error.start+(result.error_count ? 1 : 0)}} ~ {{result.error.end | number}})</small>
            <small v-if="result.error_count != result.error.end" class="pull-right">스크롤 다운시 정보가 더 표시 됩니다</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.error_count === 0"><template><div>데이터가 없습니다</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" ref="error_list">
                <pre v-if="error_list.length" slot="body" style="width: 3000px; overflow: visible;">{{result.error.data}}</pre>
                <pre v-else slot="body">
                  <template><div>데이터가 없습니다</div></template>
                </pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>점검 페이지</strong>
            <small>페이지 목록 {{result.page_count || 0 | number}} 개 ({{result.page.start+(result.page_count ? 1 : 0)}} ~ {{result.page.end | number}})</small>
            <small v-if="result.page_count != result.page.end" class="pull-right">스크롤 다운시 정보가 더 표시 됩니다</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.page_count === 0"><template><div>데이터가 없습니다</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('page')" ref="page_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.page.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>외부 페이지</strong>
            <small>참조되는 외부 페이지 목록 {{result.ext_count | number}} 개 ({{result.ext.start+(result.ext_count ? 1 : 0)}} ~ {{result.ext.end | number}})</small>
            <small v-if="result.ext_count != result.ext.end" class="pull-right">스크롤 다운시 정보가 더 표시 됩니다</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.ext_count === 0"><template><div>데이터가 없습니다.</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('ext')" ref="ext_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.ext.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>리소스 데이터</strong>
            <small>리소스 페이지 목록 {{result.resource_count | number}} 개 ({{result.resource.start+(result.resource_count ? +1 : 0)}} ~ {{result.resource.end | number}})</small>
            <small v-if="result.resource_count != result.resource.end" class="pull-right">스크롤 다운시 정보가 더 표시 됩니다</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.resource_count === 0"><template><div>데이터가 없습니다.</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('resource')" ref="resource_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.resource.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
